module.exports = __webpack_public_path__ + "img/bannerTemps.ee1316ca.jpg";